import { observer } from 'mobx-react';
import { Paper } from '@mui/material';
import { NetworkStatus } from '@apollo/client';
import { useParams, useRouteLoaderData } from 'react-router-dom';

import {
  CampContactInput,
  CampContactsDocument,
  CampContactUpdate,
  CampQuery,
  useCampContactsQuery,
  useCampPermissionQuery,
  useCheckPaymentMutation,
  useCreateCampContactMutation,
  useDeleteCampContactMutation,
  usePaymentsQuery,
  usePersonsQuery,
  useRefundPaymentMutation,
  useUpdateCampContactMutation,
} from '../../../../../generated/graphql';
import {
  CacheOperation,
  updateCacheWithCampId,
} from '../../../../../utils/updateCache';
import { CustomDialog } from '../../../../../components/common/CustomDialog';
import { ErrorLoading } from '../../../../../components/common/ErrorLoading';
import { AutoTableModal } from '../../../../../components/Modals/AutoTableModal';
import {
  TableComponent,
  TableHeader,
} from '../../../../../components/PaymentTable/Table';
import { Row, TableColumn } from '../../../../../types/tableColumn';
import { useStores } from '../../../../../stores';
import { InputType } from '../../../../../types/inputTypes';
import React, { useEffect, useState } from 'react';
import { RefundModal } from '../../../../../components/payments/RefundModal';


const headers: TableColumn[] = [
  {
    title: 'Id',
    accessor: 'id',
    inputType: InputType.Text,
    width: 50,
  },
  {
    title: 'Deltagare',
    accessor: 'person_name',
    inputType: InputType.Person,
    width: 50,
  },
  {
    title: 'Summa',
    accessor: 'amount',
    inputType: InputType.Text,
    width: 50,
  },
  {
    title: 'Status',
    accessor: 'status',
    inputType: InputType.SwishStatus,
    width: 50,
  },
  {
    title: 'Tid',
    accessor: 'modified',
    inputType: InputType.Date,
    width: 80,
  },
  {
    title: 'Typ',
    accessor: 'type',
    inputType: InputType.Text,
    width: 50,
  },
  {
    title: 'Telefon',
    accessor: 'number',
    inputType: InputType.Text,
    width: 50,
  },
  {
    title: 'Felmeddelande',
    accessor: 'swish_error',
    inputType: InputType.Text,
  },
  {
    title: 'Återbetalning',
    accessor: 'type',
    inputType: InputType.Swish,
    width: 50,
  },
];

export const CampPaymentsPage = observer(function CampPaymentsPage() {
  const stores = useStores();
  const storePayment = stores.paymentStore;
  const personStore = stores.personStore;
  const modalStore = stores.modalStore;
  const camp = useRouteLoaderData('camp') as CampQuery['camp'];
  const camp_id = camp.camp_id;
  const params = useParams();
  const card_id = parseInt(params.card_id);
  const [modalHeaders, setModalHeaders] = React.useState(headers);
  const { data, error, loading, refetch, networkStatus } = usePaymentsQuery(
    { variables: { camp_id } },
  );

  const { data: personsData } = usePersonsQuery(
    { variables: { camp_id } },
  );

  const [checkPayment] = useCheckPaymentMutation();

  useEffect(() => {

    if (data && data.payments) {
      storePayment.setPayments(data.payments);
    }

  }, [data]);

  const refetching = networkStatus === NetworkStatus.refetch;

  if (!data) {
    return <ErrorLoading {...{ loading, error }} />;
  }

  return (
    <>
      <Paper>
        <TableHeader
          title={'Betalningar'}
        />
        {!!storePayment.payments && (
          <TableComponent
            headers={headers}
            rows={storePayment.payments}
            showEdit={false}
            showDelete={false}
            permissions={[]}
            onDelete={(row) => { } }
            //@ts-ignore
            swishRefund={ function (row: Row): Promise<any> {

              console.log('row', row);
              storePayment.setActiveRefundPayment(row);


              }


             }
             //@ts-ignore
            swishCheck={ function (row: Row): Promise<any> {

              checkPayment({
                variables: {
                  id: Number(row.id),
                }
                }).then((res) => {
                  console.log('res', res);
                  refetch();
                });


            }


             } onUpdateRow={function (id: string | number, accessor: string, newValue: string | number): Promise<any> {
              throw new Error('Function not implemented.');
            } } onEdit={function (row: Row): void {
              throw new Error('Function not implemented.');
            } }
          />
        )}

      </Paper>

        <RefundModal />

    </>
  );
});

